import React from 'react';
import InventoryLocationsMenuView from '../../../containers/Inventory/InventoryLocations/InventoryLocationsMenu/InventoryLocationsMenu';

const InventoryLocationsMenu = () => {
    return (
        <InventoryLocationsMenuView />
    )
}

export default InventoryLocationsMenu